import * as React from "react";
import styled, { css } from "styled-components";
import { Alert as MantineAlert } from "@mantine/core";
import Icon from "components/common/Icon";
const StyledAlert = styled(MantineAlert)(
  ({ $bsStyle, $compact, theme }) => css`
  margin: ${theme.spacings.md} 0;
  ${$compact && css`
      padding: 7px 10px;
    `}
  background-color: ${theme.colors.alerts[$bsStyle].background};
  border: 1px solid ${theme.colors.alerts[$bsStyle].border};

  .mantine-Alert-message {
    color: ${theme.colors.text.primary};
    font-size: ${theme.fonts.size.body};
  }

  .mantine-Alert-title {
    font-size: ${theme.fonts.size.body};
    color: ${theme.colors.text.primary};
  }

  .mantine-Alert-closeButton {
    color: ${theme.colors.text.primary};
  },
`
);
const iconNameForType = (bsStyle) => {
  switch (bsStyle) {
    case "warning":
    case "danger":
      return "error";
    case "success":
      return "check_circle";
    default:
      return "info";
  }
};
const Alert = ({
  children,
  compact = false,
  bsStyle = "default",
  title = void 0,
  style = void 0,
  className = void 0,
  onDismiss = void 0,
  noIcon = false
}) => {
  const displayCloseButton = typeof onDismiss === "function";
  const iconName = iconNameForType(bsStyle);
  return /* @__PURE__ */ React.createElement(
    StyledAlert,
    {
      $bsStyle: bsStyle,
      $compact: compact,
      className,
      color: bsStyle,
      style,
      onClose: onDismiss,
      title,
      icon: noIcon ? null : /* @__PURE__ */ React.createElement(Icon, { name: iconName }),
      closeButtonLabel: displayCloseButton && "Close alert",
      withCloseButton: displayCloseButton
    },
    children
  );
};
export default Alert;
